import * as types from '../actions/actionTypes';
import appMode from '../appMode';

export const changeToDoingMode = () => {
    return { type: types.APP_MODE_CHANGED, mode: appMode.doing };
};

export const changeToManageMode = () => {
    return { type: types.APP_MODE_CHANGED, mode: appMode.manage };
};

export const changeToSettingMode = () => {
    return { type: types.APP_MODE_CHANGED, mode: appMode.setting };
};



// WEBPACK FOOTER //
// ./src/js/actions/appModeActionCreators.js